import React from "react";
import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";

const SalesProtectedRoute = ({ children }) => {
  const isAuthenticated = useSelector((state) => state.user.isAuthenticated);
  const role = useSelector((state) => state.user.role);

  if (!isAuthenticated || role !== "sales") {
    return <Navigate to="/" />;
  }

  return children;
};

export default SalesProtectedRoute;
